import { render, staticRenderFns } from "./FarmSubmission.vue?vue&type=template&id=52998f1f&scoped=true"
import script from "./FarmSubmission.vue?vue&type=script&lang=js"
export * from "./FarmSubmission.vue?vue&type=script&lang=js"
import style0 from "./FarmSubmission.vue?vue&type=style&index=0&id=52998f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52998f1f",
  null
  
)

export default component.exports